import React from 'react';
import { Grid, Paper, Typography, Skeleton } from '@mui/material';

const SummaryCards = ({ items, loading }) => {
  const placeholders = Array(4).fill(null); // asume 4 tarjetas por defecto

  const renderItem = (item, index) => (
    <Grid item xs={12} sm={6} md={3} key={index}>
      <Paper elevation={2} style={{ padding: '1rem' }}>
        <Grid container spacing={1} alignItems="center">
          <Grid item>{item.icon}</Grid>
          <Grid item>
            <Typography variant="caption" color="textSecondary">
              {item.title}
            </Typography>
            <Typography variant="body1">{item.value}</Typography>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );

  const renderSkeleton = (_, index) => (
    <Grid item xs={12} sm={6} md={3} key={index}>
      <Paper elevation={2} style={{ padding: '1rem' }}>
        <Grid container spacing={1} alignItems="center">
          <Grid item>
            <Skeleton variant="circular" width={40} height={40} />
          </Grid>
          <Grid item>
            <Skeleton width={100} height={20} />
            <Skeleton width={60} height={30} />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );

  return (
    <Grid container spacing={2}>
      {loading
        ? placeholders.map(renderSkeleton)
        : items.map(renderItem)}
    </Grid>
  );
};

export default SummaryCards;
